<app-file-management 
  (fileSelected)="submitImage($event)" 
  (closeClicked)="onClose()">
</app-file-management>